import { useCallback } from 'react';
import { CONTEXT_KEYS, useArtboardContext } from '../../../context/complexArtboardContext';
import { useVersionContext, VERSION_CONTEXT_KEYS } from '../../../context/complexVersionContext';

export const useShowVersionSettings = (selectorName = '') => {
  const readonlySelector = useCallback(store => store[CONTEXT_KEYS.READONLY_TEMPLATE], []);
  const [readOnly] = useArtboardContext(readonlySelector, selectorName);

  const versionSettingsVisibleSelector = useCallback(
    store => store[VERSION_CONTEXT_KEYS.VERSION_SETTINGS_VISIBLE],
    [],
  );
  const [versionSettingsVisible] = useVersionContext(versionSettingsVisibleSelector, selectorName);

  const showVersionSettings = versionSettingsVisible && readOnly;

  return {
    // use showVersionSettings flag when it's neccessary to control logic only for the read only version documents.
    showVersionSettings: showVersionSettings,
    readOnly: readOnly,
    versionSettingsVisible: versionSettingsVisible,
  };
};
